import { type FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ChallengeRequestScreenState } from '@shinetools/sca-operations';
import {
  Button,
  Typography,
  View,
  YStack,
} from '@shinetools/sunshine-universal';

import SunshineModal from 'components/_core/SunshineModal';

import { modalMinHeight } from '../utils/constant';
import ChallengeRequestOperationDetails from './ChallengeRequestOperationDetails';

export interface ChallengeRequestInfoProps {
  challengeId: string;
  operation: string;
  userId: string;
  originDeviceId: string;
  payload: Record<string, unknown>;
  moveState: (state: ChallengeRequestScreenState) => void;
}

const ChallengeRequestInfo: FC<ChallengeRequestInfoProps> = ({
  challengeId,
  moveState,
  operation,
  originDeviceId,
  payload,
  userId,
}) => {
  if (!challengeId || !operation || !userId) {
    throw new Error('Missing challengeId, name, operation or userId');
  }

  return (
    <>
      <SunshineModal.Body minHeight={modalMinHeight}>
        <YStack alignItems="flex-start" gap="$space.16">
          <Typography.Header textAlign="left">
            <FormattedMessage id="authentication.challenge.info.title" />
          </Typography.Header>
          <Typography.Text textAlign="justify" variant="secondary">
            <FormattedMessage id="authentication.challenge.info.short_title" />
          </Typography.Text>
        </YStack>

        <ChallengeRequestOperationDetails
          challengeId={challengeId}
          operation={operation}
          originDeviceId={originDeviceId}
          payload={payload}
        />
      </SunshineModal.Body>
      <SunshineModal.Footer flexDirection="row" gap={16}>
        <View>
          <Button
            onPress={() => moveState(ChallengeRequestScreenState.Declined)}
            variant="tertiary"
          >
            <FormattedMessage id="authentication.challenge.decline" />
          </Button>
        </View>

        <View marginLeft="30%">
          <Button
            onPress={() => moveState(ChallengeRequestScreenState.Passcode)}
          >
            <FormattedMessage id="authentication.challenge.accept" />
          </Button>
        </View>
      </SunshineModal.Footer>
    </>
  );
};

export default ChallengeRequestInfo;
